// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-64ab4d8e] .el-switch .el-switch__core,\n.el-switch .el-switch__label[data-v-64ab4d8e] {\n  width: 40px !important;\n  font-size: 12px !important;\n}", ""]);
// Exports
module.exports = exports;
